import { render, staticRenderFns } from "./VuesticDataTable.vue?vue&type=template&id=ca904068"
import script from "./VuesticDataTable.vue?vue&type=script&lang=js"
export * from "./VuesticDataTable.vue?vue&type=script&lang=js"
import style0 from "./VuesticDataTable.vue?vue&type=style&index=0&id=ca904068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/VuesticDataTable.vue
// module id = 0CcK
// module chunks = 41